// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___1iE8o","container_1":"container_1___YxCYU","container_2":"container_2___2HTeG"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Privilege/styles.module.scss
// module id = 739
// module chunks = 0